import { createTextNode as _$createTextNode } from "@opentui/solid";
import { insertNode as _$insertNode } from "@opentui/solid";
import { memo as _$memo } from "@opentui/solid";
import { createComponent as _$createComponent } from "@opentui/solid";
import { effect as _$effect } from "@opentui/solid";
import { insert as _$insert } from "@opentui/solid";
import { setProp as _$setProp } from "@opentui/solid";
import { createElement as _$createElement } from "@opentui/solid";
import { Show } from "solid-js";
import { theme } from "../theme";
export function StatusBar(props) {
  const getHints = () => {
    const focus = props.store.focus();
    if (focus === "sidebar") {
      return "↑/↓ Navigate | Enter Load | → Switch | / Toggle system | q Quit";
    } else if (focus === "grid") {
      return "↑/↓ Rows | ←/→ Columns | s Sort | Enter Detail | c Count | [/] Page | q Quit";
    } else if (focus === "row-detail") {
      return "j/k Navigate rows | Esc Close | q Quit";
    }
    return "Esc Close | q Quit";
  };
  return (() => {
    var _el$ = _$createElement("box"),
      _el$2 = _$createElement("box"),
      _el$3 = _$createElement("box"),
      _el$4 = _$createElement("text"),
      _el$6 = _$createTextNode(`Page `),
      _el$7 = _$createElement("box"),
      _el$8 = _$createElement("text");
    _$insertNode(_el$, _el$2);
    _$setProp(_el$, "borderTop", true);
    _$setProp(_el$, "paddingLeft", 1);
    _$setProp(_el$, "paddingRight", 1);
    _$insertNode(_el$2, _el$3);
    _$insertNode(_el$2, _el$7);
    _$setProp(_el$2, "flexGrow", 1);
    _$setProp(_el$2, "flexDirection", "row");
    _$setProp(_el$2, "justifyContent", "space-between");
    _$insertNode(_el$3, _el$4);
    _$insertNode(_el$4, _el$6);
    _$insert(_el$4, _$createComponent(Show, {
      get when() {
        return props.store.selectedTable();
      },
      get children() {
        return [(() => {
          var _el$5 = _$createElement("span");
          _$insert(_el$5, () => props.store.selectedTable().name);
          _$effect(_$p => _$setProp(_el$5, "style", {
            fg: theme.colors.text
          }, _$p));
          return _el$5;
        })(), " • "];
      }
    }), _el$6);
    _$insert(_el$4, () => props.store.page() + 1, null);
    _$insert(_el$4, _$createComponent(Show, {
      get when() {
        return props.store.totalCount() !== undefined;
      },
      get children() {
        return [" / ", _$memo(() => Math.ceil(props.store.totalCount() / props.store.pageSize()))];
      }
    }), null);
    _$insert(_el$4, _$createComponent(Show, {
      get when() {
        return props.store.sort().col;
      },
      get children() {
        return [" • ", _$memo(() => props.store.sort().col), " ", _$memo(() => props.store.sort().dir)];
      }
    }), null);
    _$insertNode(_el$7, _el$8);
    _$insert(_el$8, getHints);
    _$effect(_p$ => {
      var _v$ = {
          borderColor: theme.colors.border,
          backgroundColor: theme.colors.backgroundAlt
        },
        _v$2 = {
          fg: theme.colors.textDim
        },
        _v$3 = {
          fg: theme.colors.textDim
        };
      _v$ !== _p$.e && (_p$.e = _$setProp(_el$, "style", _v$, _p$.e));
      _v$2 !== _p$.t && (_p$.t = _$setProp(_el$4, "style", _v$2, _p$.t));
      _v$3 !== _p$.a && (_p$.a = _$setProp(_el$8, "style", _v$3, _p$.a));
      return _p$;
    }, {
      e: undefined,
      t: undefined,
      a: undefined
    });
    return _el$;
  })();
}